import { LegalPage } from './legal/LegalPage';
import { doc } from './legal/content/privacy-policy';

export const Privacy = () => <LegalPage doc={doc} />;
